import {
  PAGINATION_PAGE_SIZE_DEFAULT,
  PAGINATION_PAGE_SIZE_MAX,
} from '../constants'

import {
  IData_Paginated_Query,
  IData_Paginated_Query_Wrapper,
  IData_Paginated_Results_Wrapper,
  IField_Paginated_Sort_Direction,
  IData_Paginated_Sort_Descriptor,
} from '../types/pagination'

import {
  PAGINATION_SORT_DIRECTION_DEFAULT,
  PAGINATION_SORT_DIRECTION_DESCENDING,
  PAGINATION_SORT_DIRECTION_ASCENDING,
} from '../constants'

import {
  ErrorBadRequest,
} from './errors'

export function getPaginatedQuery<QueryType = any>(
  params: Record<string, any>,
  query: QueryType,
  sortDescriptor: IData_Paginated_Sort_Descriptor,
): IData_Paginated_Query_Wrapper<QueryType> {

  let pageSize: number = PAGINATION_PAGE_SIZE_DEFAULT
  let page: number = 1
  let sortColumn = sortDescriptor.defaultColumn
  let sortDirection = sortDescriptor.defaultDirection
  if(params.pagination_page_size && !isNaN(parseInt(params.pagination_page_size as string))) {
    pageSize = parseInt(params.pagination_page_size as string)
  }
  if(params.pagination_page && !isNaN(parseInt(params.pagination_page as string))) {
    page = parseInt(params.pagination_page as string)
  }
  if(params.pagination_sort_column) {
    if(sortDescriptor.columns.find(c => c[0] == params.pagination_sort_column)) {
      sortColumn = params.pagination_sort_column
    }
    else {
      throw new ErrorBadRequest(`unknown sort column ${params.pagination_sort_column}`)
    }
  }
  if(params.pagination_sort_direction) {
    if(params.pagination_sort_direction != PAGINATION_SORT_DIRECTION_DESCENDING && params.pagination_sort_direction != PAGINATION_SORT_DIRECTION_ASCENDING) {
      throw new ErrorBadRequest(`unknown sort direction ${params.pagination_sort_direction}`)
    }
    else {
      sortDirection = params.pagination_sort_direction
    }
  }
  if(pageSize > PAGINATION_PAGE_SIZE_MAX) pageSize = PAGINATION_PAGE_SIZE_MAX
  if(page<1) page = 1
  const columnDescriptor = sortDescriptor.columns.find(c => c[0] == sortColumn)
  if(!columnDescriptor) throw new ErrorBadRequest(`no column found for ${sortColumn}`)
  return {
    query,
    pagination: {
      pageSize,
      page,
      sortColumn,
      sortDirection,
      sortColumn_internal: columnDescriptor[1],
    }
  }
}

export function getPaginatedResults<DataType = any>(
  query: IData_Paginated_Query,
  total: number,
  data: DataType[],
): IData_Paginated_Results_Wrapper<DataType> {
  return {
    data,
    pagination: Object.assign({}, query, {
      total,
    }),
  }
}

export function getPaginationQueryParams(
  query: IData_Paginated_Query,
): Record<string, any> {
  return {
    pagination_page_size: query.pageSize,
    pagination_page: query.page,
    pagination_sort_column: query.sortColumn,
    pagination_sort_direction: query.sortDirection,
  }
}

export function getSortParams(
  query: IData_Paginated_Query,
  okColumns: string[],
  defaultColumn: string,
  defaultDirection?: IField_Paginated_Sort_Direction,
) {
  if(query.sortColumn && okColumns.indexOf(query.sortColumn) < 0)
    throw new ErrorBadRequest(`unknown sort column ${query.sortColumn}`)
  if(query.sortDirection && query.sortDirection != PAGINATION_SORT_DIRECTION_DESCENDING && query.sortDirection != PAGINATION_SORT_DIRECTION_ASCENDING)
    throw new ErrorBadRequest(`unknown sort direction ${query.sortDirection}`)
  const column = query.sortColumn || defaultColumn
  const direction = query.sortDirection || defaultDirection || PAGINATION_SORT_DIRECTION_DEFAULT
  return {
    column,
    direction,
  }
}
